<script setup lang="ts">
import type { Component } from 'vue'
import type { RouteLocationRaw } from 'vue-router'
import { ACTION_BUTTON_ICONS } from './actionButtonIconsConfig'

defineOptions({ inheritAttrs: false })
type ActionButtonIconKey = keyof typeof ACTION_BUTTON_ICONS

interface Props {
  tooltip: string
  icon: ActionButtonIconKey
  disabled?: boolean
  loading?: boolean
  shadowHostSelector?: string
  iconComponent?: Component | null
  iconDataTest?: string
  to?: RouteLocationRaw
  href?: string
  target?: string
  rel?: string
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
  loading: false,
  shadowHostSelector: undefined,
  iconComponent: null,
  iconDataTest: '',
})
</script>

<template>
  <OToolTip :content="props.tooltip" :shadow-host-selector="props.shadowHostSelector">
    <OButton
      size="S"
      variant="tertiary"
      roundedFull
      :disabled="props.disabled"
      :loading="props.loading"
      :to="props.to"
      :href="props.href"
      :target="props.target"
      :rel="props.rel"
      :class="{ 'disabled:!cursor-not-allowed': props.disabled }"
      v-bind="$attrs"
    >
      <template #icon>
        <component
          :is="props.iconComponent"
          v-if="props.iconComponent"
          class="shrink-0 align-middle size-(--iconsizes-l)"
        />
        <UiIcon
          v-else
          :clickable="false"
          :name="ACTION_BUTTON_ICONS[props.icon]"
          variant="solid"
          :data-test="props.iconDataTest"
        />
      </template>
    </OButton>
  </OToolTip>
</template>
